import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingBottom: 60,
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 53,
    paddingRight: 0,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
    paddingTop: 46,
    paddingLeft: 20,
    gap: 20,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    textTransform: 'uppercase',

    width: '60%',
  },
  description: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.2,

    marginTop: 20,
    width: '66%',
  },

  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 10,

    backgroundColor: '#f5f5f5',
    borderRadius: 6,

    paddingTop: 60,
    paddingBottom: 40,
    paddingHorizontal: 40,

    width: '100%',
    height: 'auto',
  },
  itemTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 50,
  },
  logoImage: {
    width: 'auto',
    height: 80,
  },
  fullWidthButton: {
    marginTop: 8,
    width: '100%',
    paddingVertical: 8,
    backgroundColor: '#000',
    alignItems: 'center',
    borderRadius: 4,
  },
  buttonText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 12,
    fontWeight: 'bold',
    textDecoration: 'none',
  },
});
